import React from 'react'
import ConfirmDialog from '../../dialog/ConfirmDialog';
import { Typography, makeStyles, createStyles, Theme, Table, TableHead, TableRow, TableBody, TableCell, withStyles, Paper, Fab, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import Constants, { breakpoint } from '../../types/constants';
import { globalStyles } from '../../style/GlobalStyles';
import { Principal } from '../../models/principal';
import BlockIcon from '@material-ui/icons/Lock'
import RestoreIcon from '@material-ui/icons/Restore'
import { PrincipalAuth, PrincipalAuthSearchModel } from '../../models/principalAuth';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { getPrincipalAuths, getPrincipalAuth, deletePrincipalAuth } from '../../services/principalAuthService';
import { useGlobal } from 'reactn';
import { IGlobalState } from '../../states/GlobalState';
import { getLevels, getIdentityFromStorage } from '../../types/auth';
import { useLogger } from '../../logger';
import {useHistory} from 'react-router-dom';
import PrincipalAuthModal from './modal';
import { Roles } from '../../models';

const contentMaxWidth = Constants.PageEditPrincipalContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    cdoroot: {
        overflow: 'auto',
        maxWidth: contentMaxWidth,
    },
    applRow: {
        display: 'flex',
        cursor: 'pointer',
        height: 28,
        fontWeight: 600,
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        }
    },
    applRowDaAutorizzare: {
        display: 'flex',
        height: 28,
        fontWeight: 100,
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        }
    },
    applNome: {
        paddingTop: 4,
        minWidth: 350,
        flex: '0 0',
    },
    applTipo: {
        paddingTop: 2,
        minWidth: 32,
        flex: '0 0',
    },
    descri: {
        paddingTop: 4,
        minWidth: 120,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        flex: '1 1',
    },
    actionicon: {
        cursor: 'pointer',
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
    actioniconblank: {
        marginRight: theme.spacing(1),
        color: 'rgba(255, 255, 255, 0.0)',
    },
    actioniconforse: {
        cursor: 'pointer',
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary,
        minWidth: 24,
        alignSelf: 'center',
    },
    scaduto: {
        cursor: 'pointer',
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary,
        // color: theme.palette.secondary.dark,
        minWidth: 24,
        alignSelf: 'center',
    },
    tableContainer: {
        width: "auto",
        marginTop: theme.spacing(2),
        overflowX: "auto",
    },
    table: {
        // minWidth: 700,
    },
    tablerow: {
        cursor: 'pointer',
    },
    filterContainer: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(0),
        display: 'flex',
    },
    fab: {
      textAlign: 'right'
    }
}))

const CustomBlockIcon = withStyles((theme: Theme) => createStyles({
    root: {
        fontSize: 20,
        color: theme.palette.secondary.main,
    },
  }))(BlockIcon);
  const ExpiredIcon = withStyles((theme: Theme) => createStyles({
    root: {
        fontSize: 20,
        color: theme.palette.primary.light,
    },
  }))(RestoreIcon);
  const CustomTableCellForIcon = withStyles((theme: Theme) => createStyles({
    body: {
        fontSize: 20,
        textAlign: 'center',
        color: theme.palette.secondary.main,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0),
        borderLeft: 'solid 1px #c0c0c0'
    },
  }))(TableCell);
  const CustomTableCell = withStyles((theme: Theme) => createStyles({
    head: {
        fontSize: 14,
        // backgroundColor: theme.palette.common.black,
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        borderLeft: 'solid 1px #c0c0c0',
    },
    body: {
        fontSize: 14,
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        borderLeft: 'solid 1px #c0c0c0'
    },
  }))(TableCell);
  const CustomTableRow = withStyles((theme: Theme) => createStyles({
    root: {
        color: "inherit",
        display: "table-row",
        outline: "none",
        verticalAlign: "middle",
        height: 28,
    },
  }))(TableRow);
  
  export type PrincipalAuthProps = {
    principal: Principal;
}

export default function PrincipalAuthList({principal }: PrincipalAuthProps) {
    const classes = useStyles();
    const gClasses = globalStyles();
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
    const closeConfirmDialog = () => setConfirmDialogOpen(false);
    const [auths, setAuths] = React.useState<PrincipalAuth[]>([]);
    const [loadingAuths, setLoadingAuths] = React.useState(false);
    const [ip,] = useGlobal<IGlobalState, 'ip'>('ip');
    const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [currentEditPrincipal,] = useGlobal<IGlobalState, 'currentEditPrincipal'>('currentEditPrincipal');
    const [globalWait, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const logger = useLogger({key: 'PrincipalAuth'});
    const history = useHistory();
    const adLevels = getLevels(auth.authData);
    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState("");
    const [prAuth, setPrAuth] = React.useState<PrincipalAuth>();
    const confirmDelete = (context: any) => {
        // handleDelete(context as ApplicationAreaDto)
    }
    let width = mobile ? 'auto' : contentMaxWidth;

    const getAuths = async (principalId: number) => {
        let model = new PrincipalAuthSearchModel();
        model.PrincipalId = principalId;        
        let myAuths = await getPrincipalAuths(ip, auth.authData!, auth.user!, model); 
        setAuths(myAuths); 
    }
    
    const _handleRowClick = (ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>, principalAuth: PrincipalAuth) => {
        if (globalWait) {return;}
        if (identity && identity.Role !== Roles.SUPERADMIN)
            return;        

        console.log(`_handleRowClick.${principalAuth.Id}`, {principalAuth})
        // TODO
        setGlobalWait(true);
        getPrincipalAuth(ip, auth.authData!, auth.user!, principalAuth.Id).then((p: PrincipalAuth)  => {
            if(p) {
                // dispatch.setCurrentEditPrincipalAndMode(p, 'Edit');
                setPrAuth(p);
                setTitle("Modifica");
                setOpen(true);
            } else {
                logger.error('Errore in recupero Principal non trovata avente id: ' + principal.Id);
            }
        }).finally(() => setGlobalWait(false));
    }
  
    const handleAdd = () => {
        console.log('*** +++ handleAdd Principal Auth')
        const newOid = 0;
        // const ownerDefault = adOwnerContext        
        // const livelloDefault = adLevels ? adLevels[0].value as number : 0;
        setTitle("Inserimento");
        var princAuth = PrincipalAuth.newItem();
        princAuth.PrincipalId = principal.Id;
        princAuth.Principal = principal;
        setPrAuth(princAuth);
        setOpen(true);
        /*
        //TODO GESTIRE NELLO STATO ma da fare prima ??
        dispatch.createNewPrincipal(newOid);
        history.push(`/principalDetail/${newOid}`);
        */
    }
    
    const handleCancel = () => {
        getAuths(principal.Id);
        setOpen(false);
    }

    const onItemDelete = (id: number) => {
        //TODO DELETE PRINCIPAL AUTH
        deletePrincipalAuth(ip, auth.authData!, auth.user!, id).then(res => {
            //refresh della lista
            getAuths(principal.Id);
        })
    }

    React.useEffect(() =>{
        
        getAuths(principal.Id);

    },[principal]);

    return (
    <>
        <Typography component="span" variant="h5" className={gClasses.inline} color="primary">Autorizzazioni</Typography>
            <div className={classes.cdoroot} style={{width: width}}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                {/* <UserLoader /> */}
                {identity && (identity.Role === Roles.SUPERADMIN || identity.Role === Roles.ADMIN) && currentEditPrincipal!.principal.CompanyId ?
                <>
                &nbsp;
                <div style={{ flex: '0 1 auto' }}>
                    <Fab color='default' size='small' className={classes.fab} title='Aggiungi Autorizzazione' 
                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}>
                        <AddIcon />
                    </Fab>
                </div>
                </>
                : null}
            </div>
            <Paper className={classes.tableContainer}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <CustomTableCell>Id</CustomTableCell>
                            <CustomTableCell>Studio</CustomTableCell>
                            <CustomTableCell>AZIONI</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {auths && auths.length 
                        ? (auths).map(principalAuth => (
                            <TableRow hover={true} key={principalAuth.Id} onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => _handleRowClick(ev, principalAuth)} className={classes.tablerow}>
                                <CustomTableCell>{principalAuth.Id}</CustomTableCell>
                                <CustomTableCell>{principalAuth.Agency?.Name}</CustomTableCell>
                                <CustomTableCell>
                                    {identity && identity.Role === Roles.SUPERADMIN ?
                                    <>
                                    <IconButton style={{padding: 0}} title='Elimina Autorizzazione' onClick={(e: any) => { e.stopPropagation(); onItemDelete(principalAuth.Id); }}><DeleteIcon /></IconButton>                                    
                                    </>
                                    : null}
                                </CustomTableCell>
                            </TableRow>
                        )) 
                        : <CustomTableRow>
                            <CustomTableCell colSpan={5}>
                                <Typography variant="h6" color="textSecondary">{loadingAuths ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                            </CustomTableCell>
                        </CustomTableRow>}
                    </TableBody>
                </Table>
            </Paper>
            </div>
        {/*auto && newAuto && <EditAutoDialog principal={props.principal} open={open} auto={auto} applArea={newAuto} onClose={handleClose} onChange={handleAutoChange} readonly={newAuto.tipo === 'AI'} isGroup={props.isGroup} />}
        {newAuto && <NewAutoDialog principal={props.principal} open={openNewAuto} auto={newAuto} onClose={handleCloseNewAuto} isGroup={props.isGroup} />
        */}
        <PrincipalAuthModal principalAuth={prAuth} open={open} onCancel={handleCancel} title={title} principal={principal}/>
        <ConfirmDialog open={confirmDialogOpen} cancel={closeConfirmDialog} confirm={confirmDelete}
            title='Cancellazione Autorizzazione' prompt="Cancello l'autorizzazione?">
            <>
                <Typography variant='body1'>Applicazione <strong>Elimino autorizzazione per l'utente</strong></Typography>
                <p></p>
            </>
        </ConfirmDialog>
    </>
    );
}